import React from 'react';
import PropTypes from 'prop-types';
import Apresentacao from '../../../components/blocosCustomizados/Apresentacao';
import { Section } from '../../../components/shared/pages';
import images from '@asserts/images/ouvidoria';

const OuvidoriaAviso = (props) => {
  const { sectionTitle } = props;

  return (
    <Apresentacao image={images.ouvidoriaExclamacao} title={sectionTitle}>
      <p>
        Estamos com uma indisponibilidade temporária e já estamos atuando para
        corrigir.
      </p>
      <p>
        Por favor, entre em contato com o nosso atendimento telefônico: 0800 702
        4240 – de segunda a sexta das 08:00h às 18:00h.
      </p>
      <p>
        Antes de começar, tenha em mãos o protocolo anterior fornecido em um dos
        nossos canais de atendimento.
      </p>
    </Apresentacao>
  );
};

OuvidoriaAviso.defaultProps = {
  ...Apresentacao.defaultProps,
  ...Section.defaultProps,
};

OuvidoriaAviso.propTypes = {
  ...Apresentacao.propTypes,
  ...Section.propTypes,
  sectionTitle: PropTypes.element.isRequired,
};

export default OuvidoriaAviso;
